import React from 'react';
import $ from 'jquery';
import './StudentWiseLibraryStatistics.css';
import 'LIBRARY/Components/Reports/ResourceListAsPerAccessionNumber/ResourceListAsPerAccessionNumber.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SuccessModal from 'LIBRARY/CommonResources/SuccessModal/SuccessModal';
import Pagination from 'react-js-pagination';
import ReactToPrint from 'react-to-print';
import ReactHtmlParser from 'react-html-parser';
import config from 'config';
import Spinner from 'LIBRARY/CommonResources/SpinnerLoader/Spinner';
import LibraryApiCall from 'LibraryApiCall';
import moment from 'moment';
import { CSVLink } from 'react-csv';
import { Link } from 'react-router-dom';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import searchPng from "LIBRARY/CommonResources/images/search-stroke.png";
import advanceFilter from "LIBRARY/CommonResources/images/advanceFilter.svg";
import { toast } from 'react-toastify';
import Select from 'react-select';
import AdvanceFilterIcon from "LIBRARY/CommonResources/images/advanceFilterIcon.png";
import ButtonLoader from 'LIBRARY/CommonResources/ButtonLoader/ButtonLoader';
import filterIcon from 'LIBRARY/CommonResources/images/filterIcon.svg';


class StudentWiseLibraryStatistics extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            successModal: false,

            // All student wise report List
            studentStatisticsListLoading: false,
            studentStatisticsListData: {},
            totalStudentStatisticsItem: 0,
            pageIndex: 1,
            limit: "10",
            linkedIidArray: [],
            academicYearSequence: [],
            academicYearList: [],
            // report filter
            // searchByName: '',
            // searchByErpId: '',
            // searchByPrnNo: '',
            searchByStudentDetails: '',
            searchByInstitute: config.institute_id,
            searchByDepartment: '',
            searchByAcademicYear: '',
            searchBySemester: '',
            searchByProgram: '',
            searchByFromDate: '',
            searchByToDate: '',
            isFilterLoading: false,

            linkedInstituteArray: {},
            academicYearArray: {},
            GetStreamList: {},
            loadingStreamData: false,
            semesterListArray: {},
            loadingStreamGroupData: false,
            programListArray: {},
            loadingProgramData: false,

            //filter button 
            showFilterModal: false,

            // custom list column
            selectAll: true,

            //STATE FOR COLUMN VISIBILITY
            exportItemVisibilityForRows: [
                { name: "Student Full Name", isVisible: true },
                { name: 'ERP ID', isVisible: true },
                { name: 'PRN No', isVisible: true },
                { name: "Institute", isVisible: true },
                { name: "Department", isVisible: true },
                { name: "Program", isVisible: true },
                { name: "Semester", isVisible: true },
                { name: "Academic Year", isVisible: true },
                { name: "Time Spent in Library (in Hrs)", isVisible: true },
                { name: "Number of Books Issued", isVisible: true },
                { name: "Number of Books Returned on Time", isVisible: true },
            ],

            //STATE FOR header
            exportCSVHeaders: [
                { label: "Student Full Name", key: 'studentFullName' },
                { label: 'ERP ID', key: 'erpId' },
                { label: 'PRN No', key: 'prnNo' },
                { label: "Institute", key: 'institute' },
                { label: "Department", key: 'department' },
                { label: "Program", key: 'program' },
                { label: "Semester", key: 'semester' },
                { label: "Academic Year", key: 'academicYear' },
                { label: "Time Spent in Library (in Hrs)", key: 'timeSpendInLibrary' },
                { label: "Number of Books Issued", key: 'noOfBooksIssued' },
                { label: "Number of Books Returned on Time", key: 'noOfBooksReturned' },
            ],

            exportItemVisibility: [
                { name: "Student Full Name", isVisible: true },
                { name: 'ERP ID', isVisible: true },
                { name: 'PRN No', isVisible: true },
                { name: "Institute", isVisible: true },
                { name: "Department", isVisible: true },
                { name: "Program", isVisible: true },
                { name: "Semester", isVisible: true },
                { name: "Academic Year", isVisible: true },
                { name: "Time Spent in Library (in Hrs)", isVisible: true },
                { name: "Number of Books Issued", isVisible: true },
                { name: "Number of Books Returned on Time", isVisible: true },
            ],

            // export all
            isExportAllReportDataFetching: false,
            allReportData: {},
            allSortedIdArray: [],
            sortedIdArray: [],

            //STATE FOR ORDER BY
            orderByStatistics: [
                { name: "Time Spent in Ascending Order", value: 'asc' },
                { name: "Time Spent in Descending Order", value: 'desc' }
            ],

            isOrderByStatisticsValue: 'asc',
            isFilterApplyButtonClick:false
        };
    }

    componentDidMount() {
        this.GetAssignedInstituteList();
        this.apiCallToGetAcademicYearList(); // academic list from config
        this.GetInstituteDepartment(); // institute department
        this.GetInstituteStreamsObject(); // department program
        this.formatCSVExportData('onLoad');
    }

    //API CALL METHOD TO GET Institute
    GetAssignedInstituteList = async () => {
        let requestData = {
            "iid": config.institute_id,
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'library_GetLinkedInstituteStatus',
            requestData,
            '/api/library/libraryLinkInstitute.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetAssignedInstituteList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                let linkedInstituteData = apiResult.linkedInstituteData;
                let linkedIidArrayValue = apiResult.linkedIidArray;

                this.setState({
                    linkedInstituteArray: linkedInstituteData,
                    linkedIidArray: linkedIidArrayValue
                });

                this.GetStudentWiseStatisticsReportList();
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting accession series list. Please try again later.'
                });
            }
        }
    }

    //API CALL METHOD TO LIST OF REPORT
    GetStudentWiseStatisticsReportList = async () => {
        this.setState({
            studentStatisticsListLoading: true
        });

        let requestData = {
            'iidArray': [this.state.searchByInstitute],
            'pageIndex': this.state.pageIndex,
            'limitPerPage': this.state.limit,
            'acaYear': this.state.searchByAcademicYear,
            'groupId': this.state.searchBySemester,
            'departmentId': this.state.searchByDepartment,
            'studentSearch': this.state.searchByStudentDetails,
            'programId': this.state.searchByProgram,
            'facultyId': config.faculty_id,
            'linkedIIDArray': this.state.linkedIidArray,
            'orderBy': this.state.isOrderByStatisticsValue,
            'fromDate': this.state.searchByFromDate,
            'toDate': this.state.searchByToDate
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'studentWiseLibraryStatisticsReport',
            requestData,
            '/api/library/instructor.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetStudentWiseStatisticsReportList()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult?.data) {
                    if (apiResult.success == 'true') {
                        this.setState({
                            studentStatisticsListData: apiResult.data,
                            totalStudentStatisticsItem: apiResult.total_count,
                            studentStatisticsListLoading: false
                        });
                    } else {
                        this.setState({
                            studentStatisticsListData: {},
                            totalStudentStatisticsItem: 0,
                            studentStatisticsListLoading: false
                        });
                    }
                } else {
                    this.setState({
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: apiResult.message,
                    });

                    this.setState({
                        studentStatisticsListData: {},
                        studentStatisticsListLoading: false
                    });
                }
            }
        }
    }

    // METHOD TO GET ACADEMIC YEAR LIST
    apiCallToGetAcademicYearList = async () => {
        let requestData = {
            "iid": this.state.searchByInstitute,
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetAcademicYearListObject',
            requestData,
            '/api/admission/streamManagement.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetAcademicYearList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;

                // Map the apiData to the desired format
                const formattedData = Object.keys(apiResult).map(key => ({
                    yearID: key,
                    yearName: apiResult[key].year_text
                }));

                this.setState({
                    academicYearArray: formattedData,
                    academicYearList: apiResult,
                    academicYearSequence: jsonResponse.APIResult.sortedIdArray,
                });
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting academic year list. Please try again later.'
                });
            }
        }
    }

    // API CALL TO GET get Institute departments List
    GetInstituteDepartment = async () => {
        this.setState({
            loadingStreamData: true,
        })
        let requestData = {
            "iid": this.state.searchByInstitute,
            "delete_status": "active"
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetInstituteDepartment',
            requestData,
            "/api/settings/instituteDepartments.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetInstituteDepartment();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                this.setState({
                    GetStreamList: apiResult.data,
                    loadingStreamData: false,
                })
            } else {
                this.setState({
                    loadingStreamData: false,
                })
            }
        }
    }

    // API CALL TO GET get departments program List
    GetInstituteStreamsObject = async () => {
        this.setState({
            loadingProgramData: true,
        })
        let requestData = {
            "iid": this.state.searchByInstitute,
            "facultyId": config.faculty_id,
            "departmentForFilter": this.state.searchByDepartment,
            "showParentGroupData": true,
            "sidArray": []
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetInstituteStreamsObject',
            requestData,
            "/api/admission/streamManagement.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetInstituteStreamsObject();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                this.setState({
                    programListArray: apiResult.data,
                    loadingProgramData: false,
                })
            } else {
                this.setState({
                    loadingProgramData: false,
                })
            }
        }
    }

    // API CALL TO GET get stream group (semester) data
    getSemesterListData = async () => {
        this.setState({
            loadingStreamGroupData: true,
        })
        let requestData = {
            "acayr": this.state.searchByAcademicYear,
            "sid": this.state.searchByProgram
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getStreamGroupList',
            requestData,
            "/api/fees/fees.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.getSemesterListData();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                this.setState({
                    semesterListArray: apiResult.streamGroupList,
                    loadingStreamGroupData: false,
                })
            } else {
                this.setState({
                    loadingStreamGroupData: false,
                })
            }
        }
    }

    // filter iid on change
    handleFilterIIdChange = (event) => {
        this.setState({ pageIndex: 1, limit: "10", searchByInstitute: event.target.value, searchByDepartment: '', searchBySemester: '', searchByProgram: '', searchByAcademicYear: '' }
            , () => {
                this.GetInstituteDepartment();  // department
                this.GetInstituteStreamsObject();  // program
                this.getSemesterListData();  // semester
            }
        );
    };

    // filter academic year on change
    handleFilterAcdyearChange = (event) => {
        this.setState({ pageIndex: 1, limit: "10", searchByAcademicYear: event.target.value, }
            , () => {
                this.getSemesterListData();  // semester
            }
        );
    };

    // filter department on change
    handleDepartmentChange = (event) => {
        this.setState({ pageIndex: 1, limit: "10", searchByDepartment: event.target.value, searchBySemester: '', searchByProgram: '' }
            , () => {
                this.GetInstituteStreamsObject();  // program
            }
        );
    };

    // filter semester on change
    handleFilterSemesterChange = (event) => {
        this.setState({ pageIndex: 1, limit: "10", searchBySemester: event.target.value, });
    };

    // filter program on change
    handleProgramChange = (event) => {
        this.setState({ pageIndex: 1, limit: "10", searchByProgram: event.target.value }
            , () => {
                this.getSemesterListData();  // semester
            }
        );
    };

    // filter student details on change
    handleStudentDetailsChange = (event) => {
        this.setState({ pageIndex: 1, limit: "10", searchByStudentDetails: event.target.value });
    };
    handleStudentDetailsKeyPress = (event) => {
        if (event.key === 'Enter') {
            // call report list API 
        }
    };

    // filter name on change
    // handleStudentNameChange = (event) => {
    //     this.setState({ pageIndex: 1, limit: "10", searchByName: event.target.value });
    // };
    // handleStudentNameKeyPress = (event) => {
    //     if (event.key === 'Enter') {
    //         // call report list API 
    //     }
    // };

    // filter ERP No on change
    // handleFilterErpNoChange = (event) => {
    //     this.setState({ pageIndex: 1, limit: "10", searchByErpId: event.target.value });
    // };
    // handleFilterErpNoKeyPress = (event) => {
    //     if (event.key === 'Enter') {
    //         // call report list API 
    //     }
    // };

    // filter PRN No on change
    // handleFilterPrnNoChange = (event) => {
    //     this.setState({ pageIndex: 1, limit: "10", searchByPrnNo: event.target.value });
    // };
    // handleFilterPrnNoKeyPress = (event) => {
    //     if (event.key === 'Enter') {
    //         // call report list API 
    //     }
    // };

    // on change for per page change
    updatePaginationCount = (pageNumber) => {
        this.setState({ pageIndex: pageNumber, searchByStudentDetails: this.state.searchByStudentDetails, searchByInstitute: this.state.searchByInstitute, searchByDepartment: this.state.searchByDepartment, searchByAcademicYear: this.state.searchByAcademicYear, searchBySemester: this.state.searchBySemester, searchByProgram: this.state.searchByProgram, searchByFromDate:this.state.searchByFromDate, searchByToDate:this.state.searchByToDate }, () => {
            this.GetStudentWiseStatisticsReportList();
        });
    };

    // on change for show entries per page
    changeShowEntriesControl = (event) => {
        this.setState({ pageIndex: 1, limit: event.target.value, searchByStudentDetails: this.state.searchByStudentDetails, searchByInstitute: this.state.searchByInstitute, searchByDepartment: this.state.searchByDepartment, searchByAcademicYear: this.state.searchByAcademicYear, searchBySemester: this.state.searchBySemester, searchByProgram: this.state.searchByProgram, searchByFromDate:this.state.searchByFromDate, searchByToDate:this.state.searchByToDate }, () => {
            this.GetStudentWiseStatisticsReportList();
        });
    }

    // CLEAR ALL FILTER
    handleClearAllReportFilter = () => {
        // searchByName: '', searchByErpId: '', searchByPrnNo: '', 
        this.setState({
            searchByStudentDetails: '', searchByInstitute: config.institute_id, searchByDepartment: '', searchByAcademicYear: '', searchBySemester: '', searchByProgram: '', searchByFromDate:'', searchByToDate:'',
            limit: "10", pageIndex: 1, isFilterApplyButtonClick:false
        }
            , () => {
                this.apiCallToGetAcademicYearList(); // academic list from config
                this.GetInstituteDepartment(); // institute department
                this.GetInstituteStreamsObject(); // department program
                this.GetStudentWiseStatisticsReportList(); // report list
            }
        )
    };

    // column visibility on change
    updateColumnDisplay = (columnIndex) => {
        let exportItemVisibilityForRows = this.state.exportItemVisibilityForRows;

        exportItemVisibilityForRows[columnIndex].isVisible = !exportItemVisibilityForRows[columnIndex].isVisible;

        this.setState({
            exportItemVisibilityForRows
        });
    }

    //FUNCTION DEFINED TO INITIATE THE EXPORT DOWNLOAD PROCESS FOR DEPARTMENT LIST
    exportCSVData = () => {
        document.getElementById('export').click();
    }

    exportAllReportCSV = () => {
        document.getElementById('exportAll').click();
    }

    // FUNCTION TO FORMAT DATA BEFORE EXPORTING
    formatCSVExportData = (action) => {
        let exportSelectedCSVHeaders = this.state.exportSelectedCSVHeaders;

        exportSelectedCSVHeaders = [{ label: "Sr.No.", key: "srNo" },];

        this.state.exportCSVHeaders.map(csvInfo => {
            this.state.exportItemVisibility.map(columnInfo => {
                if (csvInfo.label == columnInfo.name) {
                    if (columnInfo.isVisible) {
                        exportSelectedCSVHeaders.push(csvInfo);
                    }
                }
            });
        });

        this.setState({
            exportSelectedCSVHeaders
        }, () => {
            if (action != 'onLoad') {
                this.exportCSVData();
            }
        });
    }

    // export all functionality
    returnExportAllData = () => {
        // display applied filters while exporting data
        let FilterArray = [];
        let filterInstituteName = Object.values(this.state.linkedInstituteArray)?.filter((data) => data?.iid == this.state.searchByInstitute)
        let filterStudentDetails = this.state.searchByStudentDetails
        let filterAcademicYear = Object.values(this.state.academicYearArray)?.filter((data) => data?.yearID == this.state.searchByAcademicYear)
        let filterDepartment = Object.values(this.state.GetStreamList)?.filter((data) => data?.unique_id == this.state.searchByDepartment)
        let filterProgram = Object.values(this.state.programListArray)?.filter((data) => data?.id == this.state.searchByProgram)
        let filterSemester = Object.values(this.state.semesterListArray)?.filter((data) => data?.id == this.state.searchBySemester)
        let filterFromDate = this.state.searchByFromDate
        let filterToDate = this.state.searchByToDate

        if (filterStudentDetails) {
            FilterArray.push(`Student Details - ${filterStudentDetails}`)
        }
        if (this.state.searchByInstitute && filterInstituteName.length > 0) {
            FilterArray.push(`Institute - ${filterInstituteName[0].institute_name}`)
        }
        if (this.state.searchByAcademicYear && filterAcademicYear.length > 0) {
            FilterArray.push(`Academic Year - ${filterAcademicYear[0].yearName}`)
        }
        if (this.state.searchByDepartment && filterDepartment.length > 0) {
            FilterArray.push(`Department - ${filterDepartment[0].department_name}`)
        }
        if (this.state.searchByProgram && filterProgram.length > 0) {
            FilterArray.push(`Program - ${filterProgram[0].stream_name}`)
        }
        if (this.state.searchBySemester && filterSemester.length > 0) {
            FilterArray.push(`Semester - ${filterSemester[0].title}`)
        }
        if (filterFromDate) {
            FilterArray.push(`From Date - ${filterFromDate}`)
        }
        if (filterToDate) {
            FilterArray.push(`To Date - ${filterToDate}`)
        }

        return (
            <table className="table table-bordered" id="ExportAllStudentWiseLibraryStatistics" style={{ marginTop: '15px', display: 'none' }}>
                <thead>
                    <tr>
                        <tr className='d-none'>
                            <th colSpan="10" style={{ textAlign: 'center' }}>
                                {config.institute_name}
                            </th>
                        </tr>
                        <tr className='d-none'>
                            <th colSpan="10" style={{ textAlign: 'center' }}>
                                Student-wise Library Statistics Report
                            </th>
                        </tr>
                        <tr className='d-none'>
                            <th colSpan="10" ></th>
                        </tr>
                        <tr className='d-none'>
                            <th colSpan="10" style={{ textAlign: 'center' }}>
                                {
                                    FilterArray.join(" | ")
                                }
                            </th>
                        </tr>
                        <tr className='d-none'>
                            <th colSpan="10" ></th>
                        </tr>
                        <th>Sr.No</th>
                        {this.state.exportItemVisibilityForRows[0].isVisible && <th>Student Full Name</th>}
                        {this.state.exportItemVisibilityForRows[1].isVisible && <th>ERP ID</th>}
                        {this.state.exportItemVisibilityForRows[2].isVisible && <th>PRN No</th>}
                        {this.state.exportItemVisibilityForRows[3].isVisible && <th>Institute</th>}
                        {this.state.exportItemVisibilityForRows[4].isVisible && <th>Department</th>}
                        {this.state.exportItemVisibilityForRows[5].isVisible && <th>Program</th>}
                        {this.state.exportItemVisibilityForRows[6].isVisible && <th>Semester</th>}
                        {this.state.exportItemVisibilityForRows[7].isVisible && <th>Academic Year</th>}
                        {this.state.exportItemVisibilityForRows[8].isVisible && <th>Time Spent in Library (in Hrs)</th>}
                        {this.state.exportItemVisibilityForRows[9].isVisible && <th>Number of Books Issued</th>}
                        {this.state.exportItemVisibilityForRows[10].isVisible && <th>Number of Books Returned on Time</th>}
                    </tr>
                </thead>

                <tbody>
                    {
                        this.state.isExportAllReportDataFetching ?
                            <tr>
                                <td colSpan="12">
                                    <ButtonLoader />
                                </td>
                            </tr>
                            :
                            Object.keys(this.state.allReportData).length > 0 ?
                                (Object.values(this.state.allReportData).map((studentData, index) => {
                                    return (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            {this.state.exportItemVisibilityForRows[0].isVisible && <td>{studentData?.firstName + " " + studentData?.lastName || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[1].isVisible && <td>{studentData?.erpId || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[2].isVisible && <td>{studentData?.prnNo || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[3].isVisible && <td>{studentData?.instituteName || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[4].isVisible && <td>{studentData?.departmentName || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[5].isVisible && <td>{studentData?.program || ""}</td>}

                                            {this.state.exportItemVisibilityForRows[6].isVisible && <td>{studentData?.semester + " " + studentData?.lastName || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[7].isVisible && <td>{studentData?.acaYear || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[8].isVisible && <td>{studentData?.timeSpentLibrary || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[9].isVisible && <td>{studentData?.totalIssuedResource || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[10].isVisible && <td>{studentData?.totalReturnedResource || ""}</td>}

                                        </tr>
                                    )
                                })) :
                                <tr>
                                    <td colSpan="12">
                                        No data found.
                                    </td>
                                </tr>
                    }
                </tbody>
            </table>
        );
    };

    // METHOD TO GET EXPORT REPORT DATA RECURSIVELY
    methodToExportReportData = async (pageIndex) => {
        const { totalStudentStatisticsItem } = this.state;
        const totalPages = Math.ceil(totalStudentStatisticsItem / 50);
        let allReportData = { ...this.state.allReportData };
        let allSortedIdArray = [...this.state.allSortedIdArray];

        pageIndex++; // Increment page index to fetch the next set of data

        if (pageIndex <= totalPages) {
            this.setState({
                isExportAllReportDataFetching: true
            });

            let requestData = {
                'iidArray': [this.state.searchByInstitute],
                'pageIndex': pageIndex,
                'limitPerPage': 50,
                'facultyId': config.faculty_id,
                'linkedIIDArray': this.state.linkedIidArray,
            };

            let jsonResponse = await LibraryApiCall.makeApiCall(
                'studentWiseLibraryStatisticsReport',
                requestData,
                '/api/library/instructor.php'
            );

            if (jsonResponse.expired) {
                setTimeout(() => {
                    this.methodToExportReportData(pageIndex);
                }, 1000);
            } else {
                if (jsonResponse.success) {
                    let apiResult = jsonResponse.APIResult.data;

                    let sortedResponseArrayFromApi = jsonResponse.APIResult.sortedIdArray || [];

                    // Concatenate new data and update state
                    this.setState({
                        allReportData: { ...allReportData, ...apiResult },
                        allSortedIdArray: [...allSortedIdArray, ...sortedResponseArrayFromApi],
                        totalRecords: jsonResponse.APIResult.totalRecords,
                    }, () => {

                        // Fetch the next page recursively
                        this.methodToExportReportData(pageIndex);
                    });
                } else {
                    this.setState({
                        isExportAllReportDataFetching: false,
                        successModal: true,
                        successModalType: 'error',
                        successMessage: 'Something went wrong while getting assessment data. Please try again later.'
                    });
                }
            }
        } else {
            // Final step when all pages are fetched
            this.setState({
                isExportAllReportDataFetching: false,
            }, () => {
                // Trigger any further actions after fetching all data
                setTimeout(() => {
                    this.exportAllReportCSV();
                }, 500);
            });
        }
    };

    // Function to handle the order by filter
    handleOrderByChange = (value) => {
        this.setState({ isOrderByStatisticsValue: value, limit: 250 }, () => {
            this.GetStudentWiseStatisticsReportList();
        })
    }

    render() {
        // display applied filters while exporting data
        let FilterArray = [];
        let filterInstituteName = Object.values(this.state.linkedInstituteArray)?.filter((data) => data?.iid == this.state.searchByInstitute)
        let filterStudentDetails = this.state.searchByStudentDetails
        let filterAcademicYear = Object.values(this.state.academicYearArray)?.filter((data) => data?.yearID == this.state.searchByAcademicYear)
        let filterDepartment = Object.values(this.state.GetStreamList)?.filter((data) => data?.unique_id == this.state.searchByDepartment)
        let filterProgram = Object.values(this.state.programListArray)?.filter((data) => data?.id == this.state.searchByProgram)
        let filterSemester = Object.values(this.state.semesterListArray)?.filter((data) => data?.id == this.state.searchBySemester)
        let filterFromDate = this.state.searchByFromDate
        let filterToDate = this.state.searchByToDate

        if (filterStudentDetails) {
            FilterArray.push(`Student Details - ${filterStudentDetails}`)
        }
        if (this.state.searchByInstitute && filterInstituteName.length > 0) {
            FilterArray.push(`Institute - ${filterInstituteName[0].institute_name}`)
        }
        if (this.state.searchByAcademicYear && filterAcademicYear.length > 0) {
            FilterArray.push(`Academic Year - ${filterAcademicYear[0].yearName}`)
        }
        if (this.state.searchByDepartment && filterDepartment.length > 0) {
            FilterArray.push(`Department - ${filterDepartment[0].department_name}`)
        }
        if (this.state.searchByProgram && filterProgram.length > 0) {
            FilterArray.push(`Program - ${filterProgram[0].stream_name}`)
        }
        if (this.state.searchBySemester && filterSemester.length > 0) {
            FilterArray.push(`Semester - ${filterSemester[0].title}`)
        }
        if (filterFromDate) {
            FilterArray.push(`From Date - ${filterFromDate}`)
        }
        if (filterToDate) {
            FilterArray.push(`To Date - ${filterToDate}`)
        }

        return (
            <div>
                <div className="pl-3 pr-3" style={{ height: '100%' }}>
                    <div style={{ height: '100%' }}></div>
                    <div className="studentStatisticalReport">
                        {/* header */}
                        <div className="d-flex col-md-12 px-0">
                            <div className="col-md-6 d-flex justify-content-start align-items-center p-0">
                                {/* action button - filter */}
                                <div className="d-flex">
                                    <button className="btn btn-primary" style={{ fontSize: '14px', borderRadius: '7px' }} onClick={() =>
                                        this.setState({
                                            showFilterModal: !this.state.showFilterModal
                                        })
                                    }><FontAwesomeIcon size='sm' icon={["fa", "filter"]} /> Filter</button>
                                </div>
                            </div>
                            {
                                Object.keys(this.state.studentStatisticsListData).length == 0 ? null :
                                    <div className="col-md-6 d-flex justify-content-end align-items-center p-0">
                                        <div className="d-flex align-items-center">
                                            {this.state.isExportAllReportDataFetching && <div><ButtonLoader /></div>}
                                        </div>

                                        <div className="d-flex ml-2">
                                            <button className="btn outline-button" id='orderByDropdownMenu' data-toggle="dropdown" aria-expanded="false" data-bs-toggle="dropdown" aria-haspopup="true" style={{ borderRadius: '5px', boxShadow: 'none' }}> <style type="text/css" media="print">
                                                {"@page { size: auto; }"}
                                            </style>
                                                <FontAwesomeIcon size='lg' id='orderByDropdownMenu' title="Click to Order By Report" style={{ cursor: 'pointer', color: '#0465AC' }} icon={['fas', 'sort-amount-up-alt']} /></button>
                                            <div className="dropdown-menu vm-dropdown-menu" aria-labelledby='orderByDropdownMenu'>
                                                <div id='orderByDropdown'>
                                                    {
                                                        this.state.orderByStatistics.map((columnInfo, index) => {
                                                            // Determine if the current column is selected
                                                            const isSelected = this.state.isOrderByStatisticsValue === columnInfo.value;
                                                            return (
                                                                <p className="dropdown-item" style={{
                                                                    display: 'flex', justifyContent: 'space-between', fontSize: '13px', backgroundColor: isSelected ? '#e0f7fa' : 'transparent', // Highlight background if selected
                                                                    color: isSelected ? '#0465AC' : 'black', // Change text color if selected
                                                                    cursor: 'pointer'
                                                                }} key={columnInfo.name}>
                                                                    <span
                                                                        style={{ marginRight: 10, cursor: 'pointer' }}
                                                                        onClick={() => this.handleOrderByChange(columnInfo.value)}  // Trigger the change when name is clicked
                                                                    >
                                                                        {columnInfo.name}
                                                                    </span>
                                                                </p>
                                                            );
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        </div>

                                        {/* 1 action button - export data */}
                                        <div className="d-flex ml-2" title="Click to Export" >
                                            <button className="btn outline-button" id='exportDropdownMenu' data-toggle="dropdown" aria-expanded="false" data-bs-toggle="dropdown" aria-haspopup="true" style={{ borderRadius: '5px', boxShadow: 'none' }}> <style type="text/css" media="print">
                                                {"@page { size: auto; }"}
                                            </style><FontAwesomeIcon size='lg' icon={["fa", "file-export"]} style={{ cursor: "pointer", color: '#0465AC' }} /></button>

                                            {/* 2.1 action button option - export and export all */}
                                            <div className="dropdown-menu" aria-labelledby='exportDropdownMenu'>
                                                <span>
                                                    <div style={{ display: 'none' }}>
                                                        <ReactHTMLTableToExcel
                                                            id="export"
                                                            className="btn outline-button waves-effect text-capitalize"
                                                            table="studentWiseLibraryReport"
                                                            filename="StudentWiseLibraryStatistics"
                                                            sheet="tablexls"
                                                            buttonText="Export to Excel "
                                                        >
                                                        </ReactHTMLTableToExcel>
                                                    </div>
                                                    <div style={{ display: 'none' }}>
                                                        <ReactHTMLTableToExcel
                                                            id="exportAll"
                                                            className="btn outline-button waves-effect text-capitalize"
                                                            table="ExportAllStudentWiseLibraryStatistics"   // export all functionality
                                                            filename="ExportAllStudentWiseLibraryStatistics"
                                                            sheet="tablexls"
                                                            buttonText="Export All to Excel"
                                                        />
                                                    </div>
                                                    <button
                                                        onClick={this.formatCSVExportData}
                                                        className="dropdown-item"
                                                        title="Click to Export"
                                                        style={{ boxShadow: 'none' }}
                                                    >
                                                        Export
                                                    </button>
                                                    {this.state.isExportAllReportDataFetching ? (
                                                        <p className="dropdown-item">
                                                            Exporting report . . .&nbsp;
                                                            <FontAwesomeIcon
                                                                icon={["fas", "circle-notch"]}
                                                                className="rotate"
                                                            />
                                                        </p>
                                                    ) : (
                                                        <button
                                                            onClick={() => this.setState({ allReportData: {} }, () => {
                                                                this.methodToExportReportData(0)
                                                            })}
                                                            className="dropdown-item"
                                                            title="Click to Export All"
                                                            style={{ boxShadow: 'none' }}
                                                        >
                                                            Export All
                                                        </button>
                                                    )}
                                                </span>

                                            </div>

                                        </div>

                                        {/* 2 action button - print */}
                                        <div className="d-flex ml-2" title="Click to Print">
                                            <span className="print-button">
                                                <ReactToPrint
                                                    trigger={() => {
                                                        return (
                                                            <div className="print-button btn outline-button ml-2" style={{ borderRadius: '5px', boxShadow: 'none !important' }}>
                                                                <style type="text/css" media="print">
                                                                    {"@page { size: auto; }"}
                                                                </style>
                                                                <span>
                                                                    <FontAwesomeIcon icon={['fas', 'print']} size='lg' title="Click to Print" style={{ cursor: "pointer", color: '#0465AC' }} />
                                                                </span>
                                                            </div>
                                                        )
                                                    }}
                                                    content={() => this.componentRef}
                                                />
                                            </span>
                                        </div>

                                        {/* 3 action button - column visibility */}
                                        <div className="d-flex ml-2" title="Click to Customize Columns">
                                            {/* <button className="print-button btn outline-button" style={{ borderRadius: '2.77px' }}> <style type="text/css" media="print">
                                        {"@page { size: auto; }"}
                                    </style> */}
                                            <FontAwesomeIcon size='lg' id='settingsDropdownMenu' aria-expanded="false" data-toggle="dropdown" data-bs-toggle="dropdown" aria-haspopup="true" title="Click to Customize Columns" style={{ cursor: 'pointer', marginLeft: "8px", color: '#0465AC' }} color="#000" icon={['fas', 'cog']} />
                                            {/* </button> */}

                                            {/* action modal - column visibility*/}
                                            <div className="dropdown-menu vm-dropdown-menu" aria-labelledby='settingsDropdownMenu'>
                                                <div id='settingDropdown' className='settingDropdown-body'>
                                                    {
                                                        this.state.exportItemVisibilityForRows.map((columnInfo, index) => {
                                                            return (
                                                                <p className="dropdown-item" style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px' }} key={columnInfo.name} onClick={() => this.updateColumnDisplay(index)}>
                                                                    <span style={{ marginRight: 10 }}>{columnInfo.name}</span>
                                                                    <input type="checkbox" checked={columnInfo.isVisible} />
                                                                </p>
                                                            );
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                            }
                        </div>

                        {/* filter fields */}
                        {this.state.showFilterModal &&
                            <div>
                                <div className="card" style={{ boxShadow: 'none', borderRadius: '7px 7px 0px 0px', border: '1px solid #E0E8EF' }}>
                                    <div style={{ width: '100%' }}>
                                        {/* filter data form*/}
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', width: '100%', flexWrap: 'wrap', paddingLeft: '14px', justifyContent: 'space-between', paddingRight: '14px' }}>
                                            <div style={{ marginTop: '10px', display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '10px' }}>
                                                {/* Based On Search by name */}
                                                {/* <div className="mb-2  p-1">
                                                    <label className="vm_custom_body3" color='#454E52'>Search</label>
                                                    <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                        <img
                                                            src={searchPng}
                                                            style={{
                                                                position: 'absolute',
                                                                left: '10px',
                                                                top: '50%',
                                                                transform: 'translateY(-50%)',
                                                                color: '#ccc',
                                                                backgroundColor: 'white',
                                                                width: '15px',
                                                                height: '15px',
                                                                zIndex: 1,
                                                            }}
                                                        />
                                                        <input
                                                            type="text"
                                                            className="form-control formControlAutoTask"
                                                            id="searchByNameFilter"
                                                            placeholder="Search by Name "
                                                            style={{ height: '42px', color: '#808080', paddingLeft: '34px', zIndex: 0, borderRadius: '7px', width: '150px', fontSize: "13px" }}
                                                            value={this.state.searchByName} // Bind value to state
                                                            onChange={this.handleStudentNameChange} // Handle input changes
                                                            onKeyPress={this.handleStudentNameKeyPress} // Trigger API call on Enter
                                                        />
                                                    </div>
                                                </div> */}

                                                {/* Based On ERP ID */}
                                                {/* <div className="mb-2  p-1">
                                                    <label className="vm_custom_body3" color='#454E52'>ERP ID</label>
                                                    <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                        <img
                                                            src={searchPng}
                                                            style={{
                                                                position: 'absolute',
                                                                left: '10px',
                                                                top: '50%',
                                                                transform: 'translateY(-50%)',
                                                                color: '#ccc',
                                                                backgroundColor: 'white',
                                                                width: '15px',
                                                                height: '15px',
                                                                zIndex: 1,
                                                            }}
                                                        />
                                                        <input
                                                            type="text"
                                                            className="form-control formControlAutoTask"
                                                            id="searchByErpFilter"
                                                            placeholder="Search by ERP ID"
                                                            style={{ height: '42px', color: '#808080', paddingLeft: '34px', zIndex: 0, borderRadius: '7px', width: '150px', fontSize: "13px" }}
                                                            value={this.state.searchByErpId}
                                                            onChange={this.handleFilterErpNoChange} // Handle input changes
                                                            onKeyPress={this.handleFilterErpNoKeyPress} // Trigger API call on Enter
                                                        />
                                                    </div>
                                                </div> */}

                                                {/* Based On PRN No */}
                                                {/* <div className="mb-2  p-1">
                                                    <label className="vm_custom_body3" color='#454E52'>PRN No</label>
                                                    <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                        <img
                                                            src={searchPng}
                                                            style={{
                                                                position: 'absolute',
                                                                left: '10px',
                                                                top: '50%',
                                                                transform: 'translateY(-50%)',
                                                                color: '#ccc',
                                                                backgroundColor: 'white',
                                                                width: '15px',
                                                                height: '15px',
                                                                zIndex: 1,
                                                            }}
                                                        />
                                                        <input
                                                            type="text"
                                                            className="form-control formControlAutoTask"
                                                            id="searchByPrnNoFilter"
                                                            placeholder="Search by PRN No"
                                                            style={{ height: '42px', color: '#808080', paddingLeft: '34px', zIndex: 0, borderRadius: '7px', width: '150px', fontSize: "13px" }}
                                                            value={this.state.searchByPrnNo}
                                                            onChange={this.handleFilterPrnNoChange} // Handle input changes
                                                            onKeyPress={this.handleFilterPrnNoKeyPress} // Trigger API call on Enter
                                                        />
                                                    </div>
                                                </div> */}

                                                {/* Based On Search by student details */}
                                                <div className="mb-2  p-1">
                                                    <label className="vm_custom_body3" color='#454E52'>Search</label>
                                                    <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                        <img
                                                            src={searchPng}
                                                            style={{
                                                                position: 'absolute',
                                                                left: '10px',
                                                                top: '50%',
                                                                transform: 'translateY(-50%)',
                                                                color: '#ccc',
                                                                backgroundColor: 'white',
                                                                width: '15px',
                                                                height: '15px',
                                                                zIndex: 1,
                                                            }}
                                                        />
                                                        <input
                                                            type="text"
                                                            className="form-control formControlAutoTask"
                                                            id="searchByNameFilter"
                                                            placeholder="Search By Name, ERP ID, PRN No"
                                                            title="Search By Name, ERP ID, PRN No"
                                                            style={{ height: '42px', color: '#808080', paddingLeft: '34px', zIndex: 0, borderRadius: '7px', width: '150px', fontSize: "13px" }}
                                                            value={this.state.searchByStudentDetails} // Bind value to state
                                                            onChange={this.handleStudentDetailsChange} // Handle input changes
                                                        // onKeyPress={this.handleStudentDetailsKeyPress} // Trigger API call on Enter
                                                        />
                                                    </div>
                                                </div>

                                                {/* Based on iid */}
                                                <div className="mb-2 p-1">
                                                    <label className="vm_custom_body3" color='#454E52'>Institute</label>
                                                    <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                        <select
                                                            className="form-control formControlContentTask"
                                                            style={{
                                                                // width: 'auto',
                                                                width: '165px',
                                                                height: '42px',
                                                                fontSize: "12px",
                                                                fontWeight: 400,
                                                                lineHeight: '20px',
                                                                fontFamily: "'Poppins', sans-serif",
                                                                color: '#808080',
                                                                borderRadius: '7px'
                                                            }}
                                                            id="searchByInstituteFilter"
                                                            onChange={this.handleFilterIIdChange} // Attach handler here
                                                            value={this.state.searchByInstitute} // Bind dropdown value to state
                                                        >
                                                            {Object.values(this.state.linkedInstituteArray).map((member) => (
                                                                <option key={member?.iid} value={member?.iid}>
                                                                    {member?.institute_name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>

                                                {/* Based on academic year */}
                                                <div className="mb-2 p-1">
                                                    <label className="vm_custom_body3" color='#454E52'>Academic Year</label>
                                                    <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                        <select
                                                            className="form-control formControlContentTask"
                                                            style={{
                                                                // width: 'auto',
                                                                width: '165px',
                                                                height: '42px',
                                                                fontSize: "12px",
                                                                fontWeight: 400,
                                                                lineHeight: '20px',
                                                                fontFamily: "'Poppins', sans-serif",
                                                                color: '#808080',
                                                                borderRadius: '7px'
                                                            }}
                                                            id="searchByProgramFilter"
                                                            onChange={this.handleFilterAcdyearChange} // Attach handler here
                                                            value={this.state.searchByAcademicYear} // Bind dropdown value to state
                                                        >
                                                            <option value="">Select Academic Year</option>
                                                            {/* {Object.values(this.state.academicYearArray).map((member) => (
                                                                <option key={member?.yearID} value={member?.yearID}>
                                                                    {member?.yearName}
                                                                </option>
                                                            ))}
                                                             */}
                                                            {
                                                                Object.keys(this.state.academicYearList).length > 0 &&
                                                                this.state.academicYearSequence.map(yearId => {
                                                                    let year = this.state.academicYearList[yearId];
                                                                    return (
                                                                        <option value={yearId} key={yearId}>{year.year_text}</option>
                                                                    );
                                                                })
                                                            }
                                                        </select>
                                                    </div>
                                                </div>

                                                {/* Based on department */}
                                                <div className="mb-2 p-1">
                                                    <label className="vm_custom_body3" color='#454E52'>Department</label>
                                                    <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                        <select
                                                            className="form-control formControlContentTask"
                                                            style={{
                                                                // width: 'auto',
                                                                width: '165px',
                                                                height: '42px',
                                                                fontSize: "12px",
                                                                fontWeight: 400,
                                                                lineHeight: '20px',
                                                                fontFamily: "'Poppins', sans-serif",
                                                                color: '#808080',
                                                                borderRadius: '7px'
                                                            }}
                                                            id="searchByDepartmentFilter"
                                                            onChange={this.handleDepartmentChange} // Attach handler here
                                                            value={this.state.searchByDepartment} // Bind dropdown value to state
                                                        >
                                                            <option value="">Select Department</option>
                                                            {Object.values(this.state.GetStreamList).map((stream) => (
                                                                <option key={stream?.unique_id} value={stream?.unique_id} title={stream?.department_name} >
                                                                    {stream?.department_name?.length > 30 ? `${stream?.department_name.substring(0, 10)}...` : stream?.department_name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>

                                                {/* Based on program */}
                                                <div className="mb-2 p-1">
                                                    <label className="vm_custom_body3" color='#454E52'>Program</label>
                                                    <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                        <select
                                                            className="form-control formControlContentTask"
                                                            style={{
                                                                // width: 'auto',
                                                                width: '165px',
                                                                height: '42px',
                                                                fontSize: "12px",
                                                                fontWeight: 400,
                                                                lineHeight: '20px',
                                                                fontFamily: "'Poppins', sans-serif",
                                                                color: '#808080',
                                                                borderRadius: '7px'
                                                            }}
                                                            id="searchByDepartmentFilter"
                                                            onChange={this.handleProgramChange} // Attach handler here
                                                            value={this.state.searchByProgram} // Bind dropdown value to state
                                                        >
                                                            <option value="">Select Program</option>
                                                            {Object.entries(this.state.programListArray).map(([id, stream]) => (
                                                                <option key={id} value={id} title={stream?.stream_name}>
                                                                    {stream?.stream_name?.length > 30 ? `${stream?.stream_name.substring(0, 30)}...` : stream?.stream_name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>

                                                {/* Based on semester */}
                                                <div className="mb-2 p-1">
                                                    <label className="vm_custom_body3" color='#454E52'>Semester</label>
                                                    <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                        <select
                                                            className="form-control formControlContentTask"
                                                            style={{
                                                                // width: 'auto',
                                                                width: '165px',
                                                                height: '42px',
                                                                fontSize: "12px",
                                                                fontWeight: 400,
                                                                lineHeight: '20px',
                                                                fontFamily: "'Poppins', sans-serif",
                                                                color: '#808080',
                                                                borderRadius: '7px'
                                                            }}
                                                            id="searchBySemester"
                                                            onChange={this.handleFilterSemesterChange} // Attach handler here
                                                            value={this.state.searchBySemester} // Bind dropdown value to state
                                                        >
                                                            {/* Check if both program and Academic Year are selected */}
                                                            {this.state.searchByAcademicYear && this.state.searchByProgram ? (
                                                                <>
                                                                    <option value="">Select Semester</option>
                                                                    {Object.values(this.state.semesterListArray).length > 0 ? (
                                                                        Object.values(this.state.semesterListArray).map((stream) => (
                                                                            <option key={stream?.id} value={stream?.id} title={stream?.title}>
                                                                                {stream?.title?.length > 30 ? `${stream?.title.substring(0, 30)}...` : stream?.title}
                                                                            </option>
                                                                        ))
                                                                    ) : (
                                                                        <option value="" disabled>No data found</option>
                                                                    )}
                                                                </>
                                                            ) : (
                                                                <option value="" disabled>
                                                                    Select program & academic year to get semester
                                                                </option>
                                                            )}
                                                        </select>
                                                    </div>
                                                </div>

                                                {/* Based on from date */}
                                                <div className="mb-2 p-1">
                                                    <label className="vm_custom_body3" color='#454E52'>From Date</label>
                                                    <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                        <input
                                                            type="date"
                                                            className="form-control"
                                                            style={{ fontSize: '14px', paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px', height: '41px' }}
                                                            placeholder="Select From Date"
                                                            value={this.state.searchByFromDate}
                                                            // onChange={(event) => {
                                                            //     this.setState({
                                                            //         searchByFromDate: event.target.value || '', // Handle empty selection
                                                            //     });
                                                            // }}
                                                            onChange={(event) => {
                                                                const newFromDate = event.target.value || "";
                                                                this.setState(
                                                                    {
                                                                        searchByFromDate: newFromDate,
                                                                        // Reset searchByToDate if it's before the new from date
                                                                        searchByToDate:
                                                                            this.state.searchByToDate && newFromDate && this.state.searchByToDate < newFromDate
                                                                                ? ""
                                                                                : this.state.searchByToDate,
                                                                        pageIndex: 1, limit: "10"
                                                                    });
                                                            }}
                                                        />
                                                    </div>
                                                </div>

                                                {/* Based on to date */}
                                                <div className="mb-2 p-1">
                                                    <label className="vm_custom_body3" color='#454E52'>To Date</label>
                                                    <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                        <input
                                                            type="date"
                                                            className="form-control"
                                                            style={{ fontSize: '14px', paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px', height: '41px' }}
                                                            placeholder="Select To Date"
                                                            value={this.state.searchByToDate}
                                                            // onChange={(event) => {
                                                            //     this.setState({
                                                            //         searchByToDate: event.target.value || '', // Handle empty selection
                                                            //     });
                                                            // }}
                                                            onChange={(event) => {
                                                                const newToDate = event.target.value || "";

                                                                // Only validate if user actually selected a date
                                                                if (newToDate && this.state.searchByFromDate && newToDate < this.state.searchByFromDate) {
                                                                    toast.error('To Date cannot be earlier than From Date.', {
                                                                        position: "top-right",
                                                                        autoClose: 2000,
                                                                        hideProgressBar: false,
                                                                        closeOnClick: true,
                                                                        pauseOnHover: true,
                                                                        draggable: true,
                                                                        progress: undefined,
                                                                    });
                                                                    return;
                                                                }
                                                                this.setState(
                                                                    { searchByToDate: newToDate, pageIndex: 1, limit: "10" });
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="d-flex col-md-12" style={{ marginBottom: '10px' }}>
                                            <div className="col-md-6 d-flex justify-content-start align-items-center p-0">
                                                <div className="note_title"><b>Note: </b>Student data will be retrieved based on the default assigned group.</div>
                                            </div>
                                            <div className="col-md-6 d-flex justify-content-end align-items-center p-0">
                                                <div className="d-flex">
                                                    <button className="print-button btn outline-button" style={{ fontSize: '14px', borderRadius: '7px' }}
                                                        onClick={() => {
                                                            this.setState({isFilterApplyButtonClick:true})
                                                            this.GetStudentWiseStatisticsReportList()
                                                        }}
                                                    >
                                                        <style type="text/css" media="print">
                                                            {"@page { size: auto; }"}
                                                        </style>
                                                        Apply
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {
                                    // this.state.searchByName !== '' || this.state.searchByErpId !== '' || this.state.searchByPrnNo !== '' ||
                                    (this.state.isFilterApplyButtonClick && (this.state.searchByStudentDetails !== '' || this.state.searchByInstitute !== config.institute_id || this.state.searchByDepartment !== '' || this.state.searchByAcademicYear !== '' || this.state.searchBySemester !== '' || this.state.searchByProgram !== '' || this.state.searchByFromDate !== '' || this.state.searchByToDate !== '')) &&
                                    <div className='filter-apply'>
                                        <p className='vm_custom_body5'>Filters are applied.</p>
                                        <p className="clear-all vm_custom_body5" onClick={this.handleClearAllReportFilter}>Clear All</p>
                                    </div>
                                }
                            </div>
                        }

                        {/* list table */}
                        <div className="col-md-12 px-0 div_table">
                            <div className="table-responsive fixTableHead table_pad" id='tableResponsive'>
                                <div className="print-area" ref={el => this.componentRef = el}>
                                    <div className="buildingReport_logo">
                                        <img className="report-college-logo" alt="college-logo" src={config.instructorInfo.InstituteLogo} />
                                        <p className="report-college-name">{ReactHtmlParser(config.instructorInfo.InstituteName)}</p>
                                        <h3>Student-wise Library Statistics Report</h3>
                                        {
                                            FilterArray.join(" | ")
                                        }
                                    </div>
                                    <table className="table table-bordered  vm_libraryReport_table" id="studentWiseLibraryReport">
                                        <thead>
                                            <tr>
                                                <tr className='d-none'>
                                                    <th colSpan="10" style={{ textAlign: 'center' }}>
                                                        {config.institute_name}
                                                    </th>
                                                </tr>
                                                <tr className='d-none'>
                                                    <th colSpan="10" style={{ textAlign: 'center' }}>
                                                        Student-wise Library Statistics Report
                                                    </th>
                                                </tr>
                                                <tr className='d-none'>
                                                    <th colSpan="10" ></th>
                                                </tr>
                                                <tr className='d-none'>
                                                    <th colSpan="10" style={{ textAlign: 'center' }}>
                                                        {
                                                            FilterArray.join(" | ")
                                                        }
                                                    </th>
                                                </tr>
                                                <tr className='d-none'>
                                                    <th colSpan="10" ></th>
                                                </tr>
                                                <th>Sr.No</th>
                                                {this.state.exportItemVisibilityForRows[0].isVisible && <th>Student Full Name</th>}
                                                {this.state.exportItemVisibilityForRows[1].isVisible && <th>ERP ID</th>}
                                                {this.state.exportItemVisibilityForRows[2].isVisible && <th>PRN No</th>}
                                                {this.state.exportItemVisibilityForRows[3].isVisible && <th>Institute</th>}
                                                {this.state.exportItemVisibilityForRows[4].isVisible && <th>Department</th>}
                                                {this.state.exportItemVisibilityForRows[5].isVisible && <th>Program</th>}
                                                {this.state.exportItemVisibilityForRows[6].isVisible && <th>Semester</th>}
                                                {this.state.exportItemVisibilityForRows[7].isVisible && <th>Academic Year</th>}
                                                {this.state.exportItemVisibilityForRows[8].isVisible && <th>Time Spent in Library (in Hrs)</th>}
                                                {this.state.exportItemVisibilityForRows[9].isVisible && <th>Number of Books Issued</th>}
                                                {this.state.exportItemVisibilityForRows[10].isVisible && <th>Number of Books Returned on Time</th>}
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {
                                                this.state.studentStatisticsListLoading ? <tr>
                                                    <td colSpan="12">
                                                        <ButtonLoader />
                                                    </td>
                                                </tr> :
                                                    Object.keys(this.state.studentStatisticsListData).length > 0 ?
                                                        (Object.values(this.state.studentStatisticsListData).map((studentData, index) => (
                                                            <tr key={index}>
                                                                <td>{
                                                                    this.state.limit === 'all' ? index + 1 :
                                                                        ((this.state.pageIndex - 1) * this.state.limit) + index + 1
                                                                }</td>
                                                                {this.state.exportItemVisibilityForRows[0].isVisible && <td>{studentData?.firstName + " " + studentData?.lastName || ""}</td>}
                                                                {this.state.exportItemVisibilityForRows[1].isVisible && <td>{studentData?.erpId || ""}</td>}
                                                                {this.state.exportItemVisibilityForRows[2].isVisible && <td>{studentData?.prnNo || ""}</td>}
                                                                {this.state.exportItemVisibilityForRows[3].isVisible && <td>{studentData?.instituteName || ""}</td>}
                                                                {this.state.exportItemVisibilityForRows[4].isVisible && <td>{studentData?.departmentName || ""}</td>}
                                                                {this.state.exportItemVisibilityForRows[5].isVisible && <td>{studentData?.program || ""}</td>}

                                                                {this.state.exportItemVisibilityForRows[6].isVisible && <td>{studentData?.semester || ""}</td>}
                                                                {this.state.exportItemVisibilityForRows[7].isVisible && <td>{studentData?.acaYear || ""}</td>}
                                                                {this.state.exportItemVisibilityForRows[8].isVisible && <td>{studentData?.timeSpentLibrary || ""}</td>}
                                                                {this.state.exportItemVisibilityForRows[9].isVisible && <td>{studentData?.totalIssuedResource || ""}</td>}
                                                                {this.state.exportItemVisibilityForRows[10].isVisible && <td>{studentData?.totalReturnedResource || ""}</td>}

                                                            </tr>
                                                        ))) :
                                                        <tr>
                                                            <td colSpan="12">
                                                                No data found.
                                                            </td>
                                                        </tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            {
                                (Object.keys(this.state.studentStatisticsListData).length > 0 || Object.keys(this.state.studentStatisticsListData).length > this.state.limit) &&
                                <div className='row px-0'>
                                    <div className='col-md-12 px-0' style={{ background: "#f5f8fa", borderRadius: "4px" }}>
                                        <div className='row align-items-center justify-content-between'>
                                            <div className='col-lg-4 col-md-12 col-12 pl-0 hidePrint'>
                                                <div className='d-flex justify-content-lg-start justify-content-sm-center justify-content-center '>
                                                    <span className="d-flex align-items-center" style={{ fontSize: 14, marginLeft: 4 }}>
                                                        <select className="mx-2 p-1 vm_select_border" name="pageSize" id="" value={this.state.limit} onChange={this.changeShowEntriesControl}>
                                                            <option value={10}>Entries Per Page 10</option>
                                                            <option value={25}>Entries Per Page 25</option>
                                                            <option value={40}>Entries Per Page 40</option>
                                                            <option value={100}>Entries Per Page 100</option>
                                                            <option value={250}>Entries Per Page 250</option>
                                                        </select>
                                                    </span>
                                                </div>
                                            </div>
                                            <div className='col-lg-4 col-md-12 col-12 justify-content-center'>
                                                <div id="paginationContainer" className="hidePrint" style={{ margin: "12px auto" }}>
                                                    <Pagination
                                                        activePage={this.state.pageIndex}
                                                        itemsCountPerPage={this.state.limit}
                                                        totalItemsCount={this.state.totalStudentStatisticsItem}
                                                        pageRangeDisplayed={3}
                                                        onChange={this.updatePaginationCount}
                                                    />
                                                </div>
                                            </div>
                                            {
                                                this.returnExportAllData()
                                            }
                                            <div className='col-lg-4 col-md-12 col-12 pr-0 hidePrint'>
                                                <span className="d-flex justify-content-end align-items-center " style={{ fontSize: 14, marginRight: "21px" }}>
                                                    Total Records : {this.state.totalStudentStatisticsItem || 0}
                                                </span>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div >
                </div>
            </div >

        );
    }
}


export default StudentWiseLibraryStatistics;